<template>
    <div class="bgColor">
        <div class="bgColorBox">
            <div class="colorItem">
                <el-color-picker v-model="color[0].item" size="small"></el-color-picker>
                <span @click="resetColorA(defaultColor[0].item)">重置</span>
            </div>
            <div class="colorItem">
                <el-color-picker v-model="color[1].item" size="small"></el-color-picker>
                <span @click="resetColorB(defaultColor[1].item)">重置</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props:{
        defaultColor:{
            type: Array,
            default: []
        },
        color:{
            type: Array,
            default: [],
        }
    },
    methods:{
        resetColorA(color){
          this.$emit("updateBgColorA",color)
        },
        resetColorB(color){
            this.$emit("updateBgColorB",color)
        },
    }
};
</script>

<style scoped lang="scss">
.bgColor{
    margin: 10px 0;
}
.bgColorBox{
    display: flex;
    align-items: center;
    .colorItem{
        width: 100px;
        display: flex;
        align-items: center;
        span{
            margin-left: 10px;
            font-size: 14px;
            color: #999999;
        }
    }
}
</style>